import {
  GET_INSTANCESV4_REQUESTED,
  GET_INSTANCESV4_FAILURE,
  GET_INSTANCESV4_SUCCESS,
} from '../actions';

export const initialState = {
  instancesORv4: [],
  isLoading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_INSTANCESV4_REQUESTED:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_INSTANCESV4_SUCCESS:
      return {
        ...state,
        instancesORv4: action.payload.data,
        isLoading: false,
        error: null,
      };

    case GET_INSTANCESV4_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
